import * as React from 'react';
import SlidersOutlined from './sliders-outlined';
import SlidersFilled from './sliders-filled';
import type { IconCombinedProps } from './types';
const SlidersCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <SlidersFilled ref={ref} {...rest} />;
  }
  return <SlidersOutlined ref={ref} {...rest} />;
});
export default SlidersCombined;